import authorization from "../assets/newlogos/auth_new.svg";
import chargeback from "../assets/newlogos/dispute_new.svg";
import icdIcon from "../assets/newlogos/icnd_new.svg";
import executive_insights from "../assets/newlogos/executive_new.svg";
import reconcilation from "../assets/newlogos/recon_new.svg";

const AUTH_DESCRIPTION =
  "This data service provides a snapshot of key performance indicators – approved or declined transaction volume, their growth - empowering merchants to identify opportunities for authorization rate improvements. It also enables deep - dive analysis by filtering data ( e.g.- decline reason codes, card brands, MID analysis and channel type ) and examining factors such as flight and non-flight, property level analysis and issuer insights.";

const DISPUTE_DESCRIPTION =
  "This data product offers a snapshot of key performance indicators – won or lost cases to help merchants identify opportunities for charge back optimization. It facilitates deep – dive analysis by filtering data through the dispute reason codes, card brands, MIDs, issuer and channel type. Furthermore, the tool provides a win - loss rate metric enabling merchants to refine strategies and improve charge back outcomes.";

const ICND_DESCRIPTION =
  "This data service provides a snapshot of key performance indicators - interchange fees, downgrade volumes, and their cost impact - enabling merchants to identify cost optimization opportunities. It supports deep-dive analysis through filtering by downgrade reason codes, card brands, MIDs, issuer, and channel type, helping refine transaction strategies to reduce interchange costs and improve transaction qualification.";

const EXECUTIVE_INSIGHTS_DESCRIPTION =
  "This data service transforms payment, funding, and settlement data into actionable insights. It helps merchants automate reconciliation, monitor funding activity, identify discrepancies, and improve financial visibility across their payment operations.";

const RECONCILATION_DESCRIPTION =
  "This data service provides a consolidated view of payment performance across authorization, disputes, settlement, and money movement. It enables executives to monitor key business metrics, identify emerging risks and opportunities, and gain actionable insights across the end-to-end payment lifecycle.";

// Fixed display order of the dashboard cards (matches the mapped names below).
// Anything not listed here is appended at the end, alphabetically.
export const DASHBOARD_ORDER = [
  "Executive Insights Data Service",
  "Authorization Rate Improvement Data Service",
  "Interchange & Downgrade Insights Data Service",
  "Reconcilation Data Service",
  "Disputes Optimization Data Service",
];

export const sortDashboards = (reports = []) =>
  [...reports].sort((a, b) => {
    const aIndex = DASHBOARD_ORDER.indexOf(a.name);
    const bIndex = DASHBOARD_ORDER.indexOf(b.name);

    if (aIndex === -1 && bIndex === -1) {
      return a.name.localeCompare(b.name);
    }
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });

const DASHBOARD_TYPES = [
  {
    keywords: ["authorization", "auth"],
    name: "Authorization Rate Improvement Data Service",
    img: authorization,
    description: AUTH_DESCRIPTION,
  },
  {
    keywords: ["charge back", "chargeback", "dispute", "disputes"],
    name: "Disputes Optimization Data Service",
    img: chargeback,
    description: DISPUTE_DESCRIPTION,
  },
  {
    keywords: [
      "icnd",
      "interchange & downgrade insights",
      "interchange",
      "downgrade",
    ],
    name: "Interchange & Downgrade Insights Data Service",
    img: icdIcon,
    description: ICND_DESCRIPTION,
  },
  {
    keywords: ["executive insights"],
    name: "Executive Insights Data Service",
    img: executive_insights,
    btnText: "ETA 2027",
    disabled: true,
    btnStyle: "btn-disabled",
    description: EXECUTIVE_INSIGHTS_DESCRIPTION,
  },
  {
    keywords: ["reconcilation"],
    name: "Reconcilation Data Service",
    img: reconcilation,
    btnText: "ETA Q1 2027",
    disabled: true,
    btnStyle: "btn-disabled",
    description: RECONCILATION_DESCRIPTION,
  },
];

const mapDashboardType = (reportList) => {
  const mapped = reportList.map((report) => {
    const lowerName = report.name.toLowerCase();
    const match = DASHBOARD_TYPES.find((type) =>
      type.keywords.some((keyword) => lowerName.includes(keyword)),
    );

    if (match) {
      const { keywords, ...typeData } = match;
      return { ...report, ...typeData };
    }
    return { ...report };
  });

  return sortDashboards(mapped);
};

export default mapDashboardType;
